import * as React from 'react';
import { Panel, IPanelProps } from 'core/decorators/Panel';
import AlertPanelConfig from "./AlertPanelConfig";
import { DialogView, IDialogViewProps } from "../../common/views/dialog/Dialog.view"
import { IViewProps, View } from "core/decorators/View";
import { DialogConfig } from "../../common/views/dialog/DialogConfig";

 
interface IAlertPanelState{
    isOpen: boolean;
    viewKey: string;
    viewportWidth?: number;
    hasViewed: boolean;
    timeShown?: number;
}

@Panel({id: "alert", configClass: AlertPanelConfig, pageParams: false})
export class AlertPanel extends React.PureComponent<IPanelProps<AlertPanelConfig>, IAlertPanelState, IViewProps<DialogConfig>>{

    public constructor(props: IPanelProps<AlertPanelConfig>){
        super(props);
        this.state = {
            isOpen: false,
            viewKey: "alertDialog",
            hasViewed: false,
        };
    }

    public componentDidMount(){
        //could implement ability to use conditions that the ctx would like to check before displaying the alert
            //alert Intents
        if(!this.state.hasViewed  && localStorage.getItem("iosAlertShown") != "true"){
           if(navigator.userAgent.match(/iPad/i) != null || navigator.userAgent.match(/iPhone/i) != null || navigator.platform.match(/intel/i) && navigator.maxTouchPoints > 1){
               this.setState({
                   isOpen: true,
                });
            }
        }
    }

    public componentDidUpdate(prevState){
        if(localStorage.getItem("iosAlertShown") === "true" && prevState.hasViewed == true){
            this.setState({
                hasViewed: true,
            })  
        }
        else{
            this.setState({
                hasViewed: false
            })
        }
    }

    public render(){
        const { config } = this.props;

        return(
            <DialogView
                viewKey="alertDialog"
                title={config.alertTitle}
                isOpen={this.state.isOpen}
                canEscapeKeyClose={true}
                onClose={this.onClose}
                isCloseButtonShown={true}
                canOutsideClickClose={true}
                usePortal={true}
            >
                    <p style={{padding: '10px 10px 0 10px'}}>{config.alertBody}</p>
            </DialogView>
        )
    }

    private onClose = () => {
        this.setState({
            isOpen: false,
            hasViewed: true,
        });

        if(localStorage.getItem("iosAlertShown") !== "true"){
            localStorage.setItem("iosAlertShown", "true")
        }
    }
}


// WEBPACK FOOTER //
// ./src/panels/alert/AlertPanel.panel.tsx